<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.fouls', 2),
                        href: meta.links.fouls_index,
                    },
                    {
                        name: $t('messages.stats'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.subject', 1)" for="subject_id" />
                        <FormSelect
                            id="subject_id"
                            v-model="form.subject_id"
                            :options="options.subjects"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.subject_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2" v-show="options.school_years.length > 1">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.school_year')" for="school_year_id" />
                        <FormSelect
                            required
                            id="school_year_id"
                            v-model="form.school_year_id"
                            :options="options.school_years"
                            class="mt-1 w-full"
                            :null-option="false"
                        />
                        <FormError :value="form.errors.school_year_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-6">
                    <FormLabel :value="$t('messages.period')" for="period" />
                    <div class="mt-1">
                        <div
                            class="inline-flex items-center gap-x-2"
                            v-for="period in options.periods"
                            :key="period.value"
                        >
                            <label for="period" class="ml-1">
                                <input
                                    name="period"
                                    type="radio"
                                    :value="period.value"
                                    v-model="form.period"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                />
                                <span class="text-sm leading-5 font-medium text-gray-700 pl-2">
                                    {{ period.text }}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div>
            <apexchart
                :type="chartData.chart.type"
                :height="chartData.chart.height"
                :series="chartData.series"
                :options="chartData"
                v-if="chartData"
            >
            </apexchart>
        </div>

        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2 md:grid-cols-2">
            <div class="relative col-span-1 flex shadow rounded-md" v-for="teacher in teachers" :key="teacher.id">
                <div
                    class="shrink-0 flex items-center justify-center w-24 text-white text-sm leading-5 font-medium rounded-l-md overflow-hidden"
                >
                    <InertiaLink :href="teacher.links.show">
                        <img :src="teacher.avatar_or_default" alt="profile photo" />
                    </InertiaLink>
                </div>
                <div
                    class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                >
                    <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
                        <div>
                            <InertiaLink
                                :href="teacher.links.show"
                                class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
                            >
                                {{ teacher.full_name }}
                            </InertiaLink>
                        </div>
                        <div class="text-xs">
                            <div>
                                <InertiaLink :href="teacher.links.fouls">
                                    <Tippy>
                                        {{ $tc('messages.fouls', teacher.fouls_count) }} : {{ teacher.fouls_count }}

                                        <template #content>
                                            <ul class="text-sm p-1">
                                                <li v-for="type in teacher.counts" :key="type.key">
                                                    {{ type.text }} : {{ type.count }}
                                                </li>
                                            </ul>
                                        </template>
                                    </Tippy>
                                </InertiaLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import { Tippy } from 'vue-tippy';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        FormLabel,
        FormError,
        FormSelect,
        Tippy,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'chartData', 'filters', 'options', 'teachers'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: this.filters.subject_id,
                school_year_id: this.filters.school_year_id,
                period: this.filters.period,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
